<template>
	<div class="whitelist mt-5">
		<div class="row">
			<div class="col-8 offset-2 mt-5">

				<div class="card">
					<div class="card-body text-center">
						<h1 class="mt-4">Whitelist Entry</h1>

						<p class="mt-4">You have successfully been registered into the AlphaBatem Witelist. Keep an eye on our socials for important announcements & dates</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: "WhitelistSuccess",
}
</script>

<style scoped>
.card, .card-body {
	background: white;
	color: black;
}
</style>